import 'assets/css/base.scss' // 基础全局样式
import 'i18n/i18n.config.js' // 引入多语言框架
import ReactDOM from 'react-dom'
import reportWebVitals from './reportWebVitals'
import { App } from './App'
import { Provider } from 'react-redux' // redux
import { store, persistor } from 'redux/store'
import { PersistGate } from 'redux-persist/integration/react' // 数据持久化
import { ContextProvider } from 'context/loginAuthProvider' // context
import { Spin } from 'antd'
import WorldMap from 'pages/functions/WorldMap/WorldMap'

const addStateListener = () => {
    const listener = type => {
        var orig = window.history[type]
        return function () {
            var rv = orig.apply(this, arguments)
            var e = new Event(type)
            e.arguments = arguments
            window.dispatchEvent(e)
            return rv
        }
    }
    window.history.pushState = listener('pushState')
    window.history.replaceState = listener('replaceState')
}
addStateListener() // 自定义路由切换事件

// 临时页面
const worldMapURL = window.location.pathname === '/worldMapURL'

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={<Spin size='large' />} persistor={persistor}>
            <ContextProvider>{worldMapURL ? <WorldMap /> : <App />}</ContextProvider>
        </PersistGate>
    </Provider>,
    document.getElementById('root')
)

reportWebVitals() // 性能分析工具
